import { render, staticRenderFns } from "./TableTotalsBanks.vue?vue&type=template&id=e51c1630"
import script from "./TableTotalsBanks.vue?vue&type=script&lang=js"
export * from "./TableTotalsBanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports